import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

const GUIDES = [
    { to: '/guide/analyse-cv-ia', title: 'Analyse de CV par IA', desc: 'Comment l’IA évalue un CV : critères, erreurs fréquentes, exemples.' },
    { to: '/guide/optimiser-cv-ats', title: 'Optimiser son CV pour les ATS', desc: 'Structure, mots-clés et format pour passer les filtres recruteur.' },
    { to: '/guide/rediger-cv-percutant', title: 'Rédiger un CV percutant', desc: 'Formulations concrètes et adaptation par secteur.' },
    { to: '/guide/cv-reconversion-professionnelle', title: 'CV pour reconversion', desc: 'Valoriser les compétences transférables et les formations.' },
    { to: '/guide/lettre-motivation', title: 'Lettre de motivation', desc: 'Structure claire et personnalisation pour accompagner le CV.' },
    { to: '/guide/cv-etudiant', title: 'CV étudiant', desc: 'Stages, projets et compétences à mettre en avant sans longue expérience.' },
    { to: '/guide/score-cv', title: 'Améliorer son score CV', desc: 'Actions concrètes par section pour faire progresser le score.' },
    { to: '/guide/format-cv', title: 'Format de CV', desc: 'Chronologique, fonctionnel ou mixte : lequel choisir.' },
    { to: '/guide/erreurs-cv', title: 'Erreurs à éviter', desc: 'Les fautes qui font écarter un CV avant même l’entretien.' },
    { to: '/guide/photo-cv', title: 'Photo sur le CV', desc: 'Quand la mettre, quand l’éviter, et comment la choisir.' },
    { to: '/guide/longueur-cv', title: 'Longueur du CV', desc: 'Une ou deux pages : règles utiles selon le profil.' },
    { to: '/guide/mots-cles-cv', title: 'Mots-clés CV', desc: 'Lexique par secteur pour rester compatible ATS.' },
    { to: '/guide/cv-tech', title: 'CV Tech / IT', desc: 'Stack, GitHub, certifications : ce que les recruteurs tech regardent.' },
];

const GuidesIndex = () => {
    return (
        <div className="min-h-screen bg-slate-200 pt-16">
            <Helmet>
                <title>Guides CV: Analyse IA et optimisation ATS</title>
                <meta name="description" content="Tous nos guides pour améliorer votre CV: analyse par IA, passer les ATS, check-lists et exemples concrets." />
                <link rel="canonical" href="https://www.cv-analyse.fr/guides" />
            </Helmet>

            <div className="bg-slate-900 text-white">
                <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10">
                    <h1 className="text-3xl md:text-4xl font-semibold mb-2">Guides CV</h1>
                    <p className="text-slate-300 max-w-2xl">
                        Conseils pratiques pour analyser, structurer et optimiser votre CV.
                        {' '}
                        <Link to="/methode" className="text-blue-300 hover:text-white">Méthode de notation</Link>
                        {' · '}
                        <Link to="/barometre" className="text-blue-300 hover:text-white">Baromètre des scores</Link>
                        {' · '}
                        <Link to="/comparatifs" className="text-blue-300 hover:text-white">Comparatifs</Link>
                    </p>
                </div>
            </div>

            <div className="max-w-6xl mx-auto px-4 sm:px-6 py-8">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {GUIDES.map((guide) => (
                        <Link
                            key={guide.to}
                            to={guide.to}
                            className="card-surface p-5 hover:border-blue-400 block min-w-0"
                        >
                            <h2 className="text-base font-semibold text-slate-900 mb-2">{guide.title}</h2>
                            <p className="text-sm text-slate-600 mb-3 leading-relaxed">{guide.desc}</p>
                            <span className="text-sm font-medium text-blue-700">Lire le guide →</span>
                        </Link>
                    ))}
                </div>

                <div className="cta-band text-center mt-10">
                    <h3 className="text-xl font-semibold mb-2">Prêt à analyser votre CV ?</h3>
                    <p className="text-slate-300 text-sm mb-5">
                        Score et 3 conseils offerts — rapport complet dès 5 €.
                    </p>
                    <Link to="/" className="btn-primary">
                        Voir mon score
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default GuidesIndex;
